export const EXPIRED_TOKEN_ERROR_TYPE = "expired_token";
export const NON_CRITICAL_ERROR_TYPE = "non_critical";
export const SERVER_ERROR_TYPE = "server_error";
export const UNAUTHORIZED_ERROR_TYPE = "unauthorized";
export const CSV_UPLOAD_TYPE = "csv_upload";
